import { hasEventEnded } from './event-participation';
import { EVENT_SURVEY_LIMITS } from './event-survey';
const DAY_MS = 86_400_000;
/** Hazır soru i18n'den, özel soru organizatörün yazdığı dilde. */
export function surveyQuestionText(question, t) {
    return question.presetKey
        ? t.t(`eventSurvey.presets.${question.presetKey}`)
        : (question.text ?? '');
}
/** Kapanışa kalan TAM gün (yukarı yuvarlanır); kapanış geçtiyse 0. */
export function surveyDaysUntil(closesAt, now) {
    const left = new Date(closesAt).getTime() - now;
    return left <= 0 ? 0 : Math.ceil(left / DAY_MS);
}
export function toggleSurveyChoice(current, index) {
    const set = new Set(current ?? []);
    if (set.has(index))
        set.delete(index);
    else
        set.add(index);
    return [...set].sort((a, b) => a - b);
}
/** Taslaktan gönderim gövdesi: yalnız cevaplanmış sorular, türüne göre tek alan. */
export function buildSurveyAnswers(questions, draft) {
    const out = [];
    for (const question of questions) {
        const answer = draft[question.id];
        if (!answer)
            continue;
        switch (question.kind) {
            case 'rating_5':
            case 'nps_10':
                if (typeof answer.rating === 'number') {
                    out.push({ questionId: question.id, rating: answer.rating });
                }
                break;
            case 'single_choice':
            case 'multi_choice':
                if (answer.choices && answer.choices.length > 0) {
                    out.push({ questionId: question.id, choices: [...answer.choices] });
                }
                break;
            case 'short_text': {
                const text = answer.text?.trim() ?? '';
                if (text.length > 0)
                    out.push({ questionId: question.id, text });
                break;
            }
        }
    }
    return out;
}
/**
 * Sunucunun alan reddini (`answers.<sıra>.<alan>`) TEK soruya indirger: o
 * sıranın satırları `answer` yoluna taşınır (etiketi sözlükte), başka sıranın
 * satırı düşer. Sıra son gönderilen gövdedendir; soru gönderilmediyse `null`.
 */
export function surveyAnswerErrorFor(error, answerIndex) {
    if (!error || answerIndex < 0)
        return null;
    const prefix = `answers.${answerIndex}`;
    const own = (error.fieldErrors ?? []).filter((item) => item.path === prefix || item.path.startsWith(`${prefix}.`));
    if (own.length === 0)
        return null;
    return { ...error, fieldErrors: own.map((item) => ({ ...item, path: 'answer' })) };
}
/** Metin sınırı aşılmış soru var mı (istemci reddi; sunucu da reddeder). */
export function hasOverlongSurveyText(draft) {
    return Object.values(draft).some((answer) => (answer.text?.length ?? 0) > EVENT_SURVEY_LIMITS.answerTextMax);
}
/** Geçmiş satırı özete aday: bitmiş, iptal edilmemiş ve check-in yapılmış katılım. */
export function isPostEventCandidate(item, now) {
    return (item.outcome.checkedIn === true &&
        item.event.status !== 'cancelled' &&
        hasEventEnded(item.event.endsAt, now));
}
/**
 * Satırda en az bir eylem ya da etiket var mı (belge açık, anket açık ya da
 * gönderilmiş)? Yoksa satır eylemsiz kalır; kapanmış ankette eylem yok.
 */
export function hasPostEventActions(status) {
    if (!status)
        return false;
    const state = status.survey?.state;
    return status.certificateEnabled || state === 'open' || state === 'submitted';
}
//# sourceMappingURL=event-survey-participant.js.map